import getClient from "./ApiClient";
import { readMe, readUser, readUsers, updateMe, readItems } from "@directus/sdk";

export type SelectableUser = {
  id: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  role?:
    | string
    | {
      id?: string;
      name?: string;
    }
    | null;
};

async function getMe() {
  const clientInstance = await getClient();
  return clientInstance.request(readMe({
    fields: [
      "*",
      "policies.policy.id",
      "policies.policy.name",
      "phone",
      "preferred_email",
      "contact_info_updated_date_utc"
    ] as any
  }));
}

export async function getAssignableUsers(): Promise<SelectableUser[]> {
  const clientInstance = await getClient();
  return clientInstance.request(
    readItems("directus_users", {
      fields: ["id", "first_name", "last_name", "email", "role", "role.id", "role.name"],
      sort: ["first_name", "last_name"],
      filter: {
        status: {
          _eq: "active"
        }
      }
    })
  ) as Promise<SelectableUser[]>;
}

export async function getUsersByRole(roleName: string): Promise<SelectableUser[]> {
  const clientInstance = await getClient();
  return clientInstance.request(
    readUsers({
      fields: ["id", "first_name", "last_name", "email", "role"],
      sort: ["first_name", "last_name"],
      filter: {
        status: { _eq: "active" },
        role: { name: { _eq: roleName } }
      }
    })
  ) as Promise<SelectableUser[]>;
}

export default getMe;

export async function updateMyContactInfo(data: {
  phone: string;
  preferred_email: string;
}): Promise<void> {
  const clientInstance = await getClient();

  await clientInstance.request(updateMe({
    ...data,
    contact_info_updated_date_utc: new Date().toISOString()
  } as any));
}

export async function getUserContactInfo(id: string) {
  const clientInstance = await getClient();
  return await clientInstance.request(readUser(id, {
    fields: ["email", "phone"]
  }));
}

export async function getUsers(capabilityNames: string[], search?: string) {
  const clientInstance = await getClient();

  const capabilityFilter = {
    _or: [
      { role: { name: { _in: capabilityNames } } },
      { policies: { policy: { name: { _in: capabilityNames } } } }
    ]
  };

  const searchFilter = search?.trim()
    ? {
        _or: [
          { first_name: { _icontains: search.trim() } },
          { last_name: { _icontains: search.trim() } },
          { cod_curso: { _icontains: search.trim() } }
        ]
      }
    : null;

  const filter = searchFilter
    ? { _and: [capabilityFilter, searchFilter] }
    : capabilityFilter;

  return clientInstance.request(readUsers({
    fields: [
      "id", "first_name", "last_name", "cod_curso"
    ] as any,
    filter: filter as any,
    sort: ["first_name", "last_name"],
    limit: 20
  }));
}
